import React from "react"
import PropTypes from "prop-types"
import * as Icon from "react-feather"

import SbImageService, { isSvg } from "../../helpers/SbImageService"

const EventItem = ({
  feature,
  hero,
  url,
  image,
  date,
  name,
  location,
  tags,
  description,
}) => (
  <a className="event-item" href={url}>
    {feature && (
      <div className="event-item__feature">
        <Icon.Star className="icon icon--sm" />
        <p className="event-item__feature-text">Top pick</p>
      </div>
    )}
    {!hero ? (
      <div className="event-item__image">
        <img
          data-src={SbImageService(image)}
          className="lazyload event-item__image-img"
          alt={image}
          title={image}
        />
      </div>
    ) : (
      <div
        className="lazyload event-item__image"
        data-bg={SbImageService(image)}
        style={isSvg(image) ? { backgroundImage: `url("${image}")` } : null}
      >
        <img
          data-src={SbImageService(image)}
          className="lazyload event-item__image-img event-item__image-img--feature"
          alt={image}
          title={image}
        />
      </div>
    )}
    <div className="event-item__card">
      {date && <p className="event-item__date">{date}</p>}
      <p className="event-item__name">{name}</p>
      {location && <p className="event-item__location">{location}</p>}
      {description && <p>{description}</p>}
      {tags.length > 0 && (
        <div className="event-item__program-list">
          {tags.map(
            (tag, index) =>
              tag && (
                <div className="event-item__program-item" key={index}>
                  <p>{tag}</p>
                </div>
              )
          )}
        </div>
      )}
    </div>
  </a>
)

EventItem.defaultProps = {
  feature: false,
  hero: false,
  url: "",
  image: "https://via.placeholder.com/500x250",
  date: "",
  name: "Event title",
  location: "",
  tags: [],
}

EventItem.propTypes = {
  feature: PropTypes.bool,
  hero: PropTypes.bool,
  url: PropTypes.string,
  image: PropTypes.string,
  date: PropTypes.string,
  name: PropTypes.string,
  location: PropTypes.string,
}

export default EventItem
